// Helpers for records that reach Odoo through the queue.

/* eslint-disable @typescript-eslint/no-explicit-any */

const statusOf = (item: any) => String(item?.status || '').toLowerCase();

export const isQueued = (item: any) => statusOf(item) === 'queued';
export const isFailed = (item: any) => statusOf(item) === 'failed';
/** Saved on our side but not in Odoo yet. */
export const isUnsynced = (item: any) => isQueued(item) || isFailed(item);

/**
 * What to show as a record's number: the Odoo id (or sequence) once it has
 * one, the queue job id until then. Never call `.toString()` on `item.id`
 * directly: it is empty while the record is queued.
 */
export const recordRef = (item: any, odooRef: any = item?.id) =>
  odooRef
    ? String(odooRef)
    : `Job ${String(item?.jobId || item?._id || '')
        .slice(-6)
        .toUpperCase()}`;
